{
  "app": {
    "nom": "Recorregut",
    "carregant": "Carregant",
    "tancar": "Tancar",
    "cancellar": "Cancel·lar",
    "desar": "Desar",
    "reintentar": "Tornar-ho a provar",
    "saltarAlContingut": "Saltar al contingut principal"
  },
  "idioma": {
    "canviar": "Canviar d'idioma"
  },
  "navegacio": {
    "mapa": "Mapa",
    "classificacio": "Classificació",
    "menu": "Menú principal"
  },
  "sessio": {
    "iniciada": "Sessió iniciada. Ja podeu començar el recorregut.",
    "noValida": "Aquest codi QR no és vàlid. Comproveu l'enllaç del correu.",
    "sortir": "Tancar la sessió",
    "sensesessio": "No heu iniciat cap sessió",
    "sensesessioDetall": "Podeu consultar el mapa i els punts. Per respondre les preguntes cal inscriure's a un esdeveniment i escanejar el codi QR que rebreu per correu."
  },
  "mapa": {
    "precisio": "Precisió aproximada de {{metres}}",
    "descripcio": "Mapa amb els punts del recorregut. Si feu servir un lector de pantalla, la llista de punts que hi ha a sota conté la mateixa informació en format accessible."
  },
  "geolocalitzacio": {
    "activar": "Activar la ubicació",
    "explicacio": "Per detectar quan arribeu a un punt cal accés a la ubicació. L'aplicació només la utilitza mentre la teniu oberta i no la desa enlloc.",
    "denegada": "Heu denegat l'accés a la ubicació. Podeu activar-lo des dels ajustos del navegador.",
    "noDisponible": "Aquest dispositiu no permet obtenir la ubicació.",
    "error": "No s'ha pogut obtenir la ubicació.",
    "cercant": "Cercant la ubicació",
    "activa": "Ubicació activa",
    "pantallaEncesa": "La pantalla es mantindrà encesa mentre feu el recorregut"
  },
  "punt": {
    "distancia": "A {{distancia}}",
    "arribat": "Ja hi sou",
    "visitat": "Visitat",
    "noVisitat": "Pendent",
    "respost": "Respost",
    "sensVideo": "Aquest punt encara no té vídeo.",
    "acostarse": "Acosteu-vos a menys de {{radi}} per activar aquest punt.",
    "llistaTitol": "Punts del recorregut",
    "cap": "Encara no hi ha punts publicats.",
    "variosTitol": "Sou a prop de diversos punts",
    "variosAjuda": "Toqueu el punt on sou ara mateix."
  },
  "video": {
    "titol": "Vídeo del punt",
    "reproduir": "Reproduir el vídeo",
    "silenciat": "El vídeo comença sense so perquè el navegador no permet engegar-lo amb àudio automàticament. Toqueu la icona de so per activar-lo.",
    "bloquejat": "El navegador ha bloquejat la reproducció automàtica. Toqueu el botó per veure el vídeo.",
    "descripcio": "Descripció del contingut",
    "noCompatible": "El vostre navegador no pot reproduir aquest vídeo.",
    "subtitols": "Subtítols",
    "activarSo": "Activar el so"
  },
  "pregunta": {
    "titol": "Pregunta",
    "respondre": "Enviar la resposta",
    "capSeleccionada": "Cal triar una opció abans d'enviar.",
    "intentUnic": "Només teniu un intent. Un cop enviada, la resposta no es pot canviar.",
    "correcta": "Resposta correcta",
    "incorrecta": "Resposta incorrecta",
    "puntsObtinguts_one": "{{punts}} punt",
    "puntsObtinguts_other": "{{punts}} punts",
    "haviaRespost": "Ja havíeu respost aquesta pregunta.",
    "explicacio": "Explicació",
    "calVisitar": "Primer heu d'arribar al punt perquè s'activi la pregunta.",
    "foraDeFranja": "L'esdeveniment no està actiu en aquest moment."
  },
  "classificacio": {
    "titol": "Classificació",
    "posicio": "Posició",
    "equip": "Equip",
    "punts": "Punts",
    "encerts": "Encerts",
    "durada": "Durada",
    "senseDades": "Encara no hi ha cap equip amb puntuació.",
    "actualitzat": "Actualitzat a les {{hora}}",
    "actualitzar": "Actualitzar",
    "enCurs": "Esdeveniment en curs",
    "acabat": "Esdeveniment acabat",
    "vosaltres": "El vostre equip"
  },
  "registre": {
    "titol": "Inscripció",
    "nomEquip": "Nom de l'equip",
    "responsable": "Persona responsable",
    "telefon": "Telèfon de contacte",
    "numPersones": "Nombre de persones",
    "menors": "Els menors d'edat han d'anar acompanyats de la persona adulta responsable de l'equip.",
    "email": "Correu electrònic",
    "idiomaPreferit": "Idioma preferit",
    "consentimentTitol": "Protecció de dades",
    "consentiment": "He llegit i <destacat>accepto</destacat> el tractament de les meves dades personals d'acord amb la <politica>política de privacitat</politica>.",
    "consentimentDetall": "Fem servir el nom, el telèfon i el correu només per gestionar l'esdeveniment i enviar-vos el codi QR. Les dades de contacte se suprimeixen passat el termini de conservació.",
    "enviar": "Inscriure l'equip",
    "enviant": "Enviant",
    "fet": "Inscripció completada",
    "fetDetall": "Us hem enviat el codi QR a {{email}}. També podeu començar directament des d'aquest dispositiu.",
    "correuFallat": "No hem pogut enviar el correu, però la inscripció s'ha desat. Podeu començar des d'aquest dispositiu o demanar el codi a l'organització.",
    "comencar": "Començar el recorregut",
    "tancat": "Les inscripcions per a aquest esdeveniment estan tancades.",
    "obligatori": "Aquest camp és obligatori",
    "emailNoValid": "Escriviu una adreça de correu vàlida",
    "telefonNoValid": "Escriviu un telèfon vàlid",
    "personesNoValid": "Indiqueu com a mínim una persona",
    "consentimentObligatori": "Cal acceptar el tractament de dades per continuar",
    "grupEquip": "Dades de l'equip",
    "grupContacte": "Com us avisem",
    "grupContacteAjuda": "Aquí rebreu el codi QR per començar.",
    "quan": "Quan",
    "puntsDelRecorregut": "Punts",
    "passos": "Com funciona",
    "pas1": "Ompliu el formulari i rebreu un codi QR per correu.",
    "pas2": "El dia de la gimcana, escanegeu el codi i comença el recorregut.",
    "pas3": "A cada punt, un vídeo i una pregunta. Només teniu un intent."
  },
  "peu": {
    "privacitat": "Política de privacitat",
    "credit": "Gimcana del barri d'Hostafrancs"
  },
  "errors": {
    "titol": "Alguna cosa no ha anat bé",
    "sesion_no_valida": "La sessió no és vàlida. Torneu a escanejar el codi QR.",
    "sesion_requerida": "Cal iniciar la sessió amb el codi QR de l'equip.",
    "evento_no_encontrado": "No hem trobat aquest esdeveniment.",
    "evento_no_activo": "Aquest esdeveniment no està actiu.",
    "evento_fuera_de_franja": "L'esdeveniment encara no ha començat o ja no està actiu.",
    "evento_terminado": "L'esdeveniment ja ha acabat.",
    "registro_cerrado": "Les inscripcions ja estan tancades.",
    "punto_no_encontrado": "No hem trobat aquest punt.",
    "punto_no_pertenece_al_evento": "Aquest punt no forma part del vostre esdeveniment.",
    "visita_no_registrada": "Primer heu d'arribar al punt.",
    "demasiado_lejos": "Sou massa lluny del punt. Us falten uns {{distancia}} metres.",
    "pregunta_no_disponible": "Aquesta pregunta no està disponible.",
    "respuesta_ya_enviada": "Ja havíeu enviat una resposta.",
    "opcion_no_valida": "Aquesta opció no és vàlida.",
    "datos_no_validos": "Hi ha dades que no són correctes.",
    "credenciales_no_validas": "Les credencials no són correctes.",
    "no_autorizado": "No teniu permís per fer això.",
    "demasiadas_peticiones": "Heu fet massa peticions seguides. Espereu una mica.",
    "error_interno": "Hi ha hagut un error al servidor. Torneu-ho a provar.",
    "xarxa": "No hi ha connexió amb el servidor. Comproveu la cobertura.",
    "ruta_no_encontrada": "Aquesta adreça no existeix.",
    "rutaTitol": "Aquesta pàgina no existeix",
    "rutaDetall": "L'adreça que heu obert no correspon a cap pantalla de l'aplicació. Comproveu que l'enllaç estigui sencer.",
    "enllacTitol": "L'enllaç d'accés no és vàlid",
    "enllacDetall": "Aquest enllaç està incomplet o mal copiat. Torneu al correu amb el vostre codi QR i obriu-lo sencer, o escanegeu el codi amb la càmera. Si no el trobeu, demaneu a l'organització que us el torni a enviar.",
    "anarAlRecorregut": "Anar al recorregut",
    "correo_no_enviado": "No s'ha pogut enviar el correu. Reviseu la configuració de correu del servidor.",
    "participante_anonimizado": "Aquest equip ja no té adreça de correu: les dades es van esborrar."
  },
  "pwa": {
    "actualitzacio": "Hi ha una versió nova de l'aplicació",
    "actualitzar": "Actualitzar ara",
    "mesTard": "Més tard"
  },
  "admin": {
    "titol": "Administració",
    "entrar": "Entrar",
    "sortir": "Sortir",
    "email": "Correu electrònic",
    "contrasenya": "Contrasenya",
    "punts": "Punts",
    "esdeveniments": "Esdeveniments",
    "participants": "Participants",
    "editar": "Editar",
    "desactivar": "Desactivar",
    "actiu": "Actiu",
    "inactiu": "Inactiu",
    "exportar": "Exportar CSV",
    "veureQr": "Veure el codi QR",
    "nom": "Nom",
    "descripcio": "Descripció",
    "latitud": "Latitud",
    "longitud": "Longitud",
    "radi": "Radi en metres",
    "videoUrl": "Adreça del vídeo",
    "videoDescripcio": "Descripció del vídeo",
    "subtitolsUrl": "Adreça dels subtítols",
    "inici": "Inici",
    "fi": "Fi",
    "pregunta": "Pregunta",
    "opcions": "Opcions",
    "respostaCorrecta": "Resposta correcta",
    "puntsAtorgats": "Punts atorgats",
    "explicacioBase": "Explicació base",
    "explicacioAmpliada": "Explicació ampliada",
    "afegirOpcio": "Afegir opció",
    "esborrarOpcio": "Esborrar opció",
    "capPunt": "Encara no hi ha punts.",
    "capEsdeveniment": "Encara no hi ha esdeveniments.",
    "traduccioPendent": "Falta la traducció en {{idioma}}",
    "clicarMapa": "Feu clic al mapa per situar el punt",
    "nouPunt": "Nou punt",
    "editarPunt": "Editar el punt",
    "nouEsdeveniment": "Nou esdeveniment",
    "editarEsdeveniment": "Editar l'esdeveniment",
    "posicio": "Posició",
    "ordre": "Ordre al recorregut",
    "equip": "Equip",
    "dataRegistre": "Data de registre",
    "obrirDetall": "Veure el detall",
    "tancarDetall": "Amagar el detall",
    "detallEsdeveniment": "Detall de l'esdeveniment",
    "puntsIPreguntes": "Punts i preguntes",
    "enllacInscripcio": "Enllaç d'inscripció",
    "afegirPunt": "Afegir un punt a l'esdeveniment",
    "treureDelEsdeveniment": "Treure de l'esdeveniment",
    "capPuntAlEsdeveniment": "Aquest esdeveniment encara no té cap punt associat.",
    "capParticipant": "Encara no hi ha cap equip inscrit.",
    "preguntaDe": "Pregunta de {{punt}}",
    "marcarCorrecta": "Opció {{id}} (marqueu-la si és la correcta)",
    "senseVideo": "Sense vídeo",
    "videoYoutube": "Vídeo allotjat a YouTube: començarà sense so i connectarà amb Google.",
    "videoArxiu": "Fitxer de vídeo propi: pot començar amb so i no depèn de tercers.",
    "qrDe": "Codi QR de l'equip {{equip}}",
    "ajudaQr": "Mostreu aquest codi a l'equip si no els ha arribat el correu.",
    "ajudaRadi": "Amb el GPS de ciutat, per sota de 25 m costa que el punt s’activi.",
    "ajudaVideo": "Podeu enganxar un enllaç de YouTube o l’adreça d’un fitxer de vídeo.",
    "ajudaVideoDescripcio": "Text alternatiu per a qui no pot veure el vídeo. És obligatori.",
    "ajudaSubtitols": "Adreça del fitxer de subtítols en format WebVTT.",
    "ajudaFranja": "Hora local. Les inscripcions es tanquen automàticament a l’hora de fi.",
    "ajudaActiu": "Si el desactiveu, l’esdeveniment queda suspès encara que sigui dins de la franja.",
    "ajudaExplicacio": "Es mostra sempre després de respondre, tant si s’encerta com si no.",
    "ajudaOrdre": "Només ordena la llista, no obliga a seguir-lo.",
    "avisSolapament": "Aquest punt se solapa amb: {{punts}}. Els dos es podrien activar alhora.",
    "avisOpcionsIncompletes": "Falten textos d’opcions en: {{idiomes}}. Aquests idiomes no es publicaran.",
    "avisDadesPersonals": "Aquesta taula conté dades personals. No la compartiu ni en feu captures.",
    "falta_nom": "Cal el nom com a mínim en un idioma.",
    "falta_posicio": "Cal situar el punt al mapa.",
    "falta_franja": "Cal indicar la data d’inici i la de fi.",
    "franjaIncoherent": "La data de fi ha de ser posterior a la d’inici.",
    "falta_enunciat": "Cal l’enunciat com a mínim en un idioma.",
    "falten_opcions": "Cal com a mínim dues opcions.",
    "falta_correcta": "Cal marcar quina opció és la correcta.",
    "falten_textos_opcions": "Cal omplir les opcions com a mínim en un idioma sencer.",
    "elMeuCompte": "El meu compte",
    "canviarContrasenya": "Canviar la contrasenya",
    "contrasenyaActual": "Contrasenya actual",
    "contrasenyaNova": "Contrasenya nova",
    "repetirContrasenya": "Repetiu la contrasenya nova",
    "ajudaContrasenya": "Com a mínim {{minim}} caràcters. Feu servir una que no useu enlloc més.",
    "contrasenyaCurta": "La contrasenya ha de tenir com a mínim {{minim}} caràcters.",
    "contrasenyesNoCoincideixen": "Les dues contrasenyes noves no coincideixen.",
    "contrasenyaRepetida": "La contrasenya nova ha de ser diferent de l’actual.",
    "contrasenyaCanviada": "Contrasenya canviada. Les sessions ja obertes segueixen actives fins que caduquin.",
    "qrCartell": "QR del cartell",
    "ajudaQrCartell": "Aquest codi porta al formulari d'inscripció. És igual per a tothom i no conté cap dada personal: es pot imprimir i penjar al carrer sense cap problema.",
    "qrCartellAlt": "Codi QR d'inscripció a {{esdeveniment}}",
    "apuntaA": "Apunta a:",
    "descarregarQr": "Descarregar per imprimir",
    "ajudaImpressio": "La imatge és de 2048 píxels: es pot imprimir a mida foli sense que es vegi dentat.",
    "reenviarAlEquip": "Reenviar a l'equip",
    "reenviarAMi": "Enviar-me'n una còpia",
    "reenviant": "Enviant...",
    "reenviamentFet": "Enviat a {{adreca}}",
    "ajudaReenviament": "El correu de l'equip va a l'adreça amb què es va inscriure. La còpia va a l'adreça de la vostra sessió d'administració i porta un avís que és una còpia.",
    "reenviamentAnonimitzat": "Aquest equip ja no té dades de contacte: es van esborrar en complir-se el termini de conservació. El codi QR de sobre continua sent vàlid i se'ls pot ensenyar en pantalla.",
    "veureElLloc": "Veure el lloc públic",
    "qr": "QR",
    "idiomaBase": "base",
    "fontVideoPropi": "Fitxer propi",
    "fontVideoYoutube": "YouTube",
    "esborrarOpcioDe": "Esborrar opció {{id}}"
  },
  "diagnostic": {
    "titol": "Diagnòstic de GPS",
    "intro": "Eina per a la prova de camp. Mesura la precisió real del dispositiu i la distància a cada punt. No registra cap visita ni altera el recorregut.",
    "comencar": "Començar la mesura",
    "reiniciar": "Reiniciar les dades",
    "copiar": "Copiar les dades",
    "copiat": "Dades copiades",
    "descarregar": "Descarregar CSV",
    "estatActual": "Estat actual",
    "precisio": "Precisió",
    "lectures": "Lectures",
    "latitud": "Latitud",
    "longitud": "Longitud",
    "estadistiques": "Precisió durant la sessió",
    "millor": "Millor",
    "mediana": "Mediana",
    "pitjor": "Pitjor",
    "durada": "Durada",
    "ajudaMediana": "La mediana és el valor de referència: aguanta millor els pics aïllats que la mitjana.",
    "distancies": "Distància a cada punt",
    "punt": "Punt",
    "distancia": "Distància",
    "estat": "Estat",
    "rebots": "Canvis",
    "dins": "Dins del radi",
    "marge": "Dins del marge del servidor",
    "fora": "Fora",
    "senseposicio": "Encara no hi ha posició.",
    "canvis": "Entrades i sortides",
    "ajudaCanvis": "Cada entrada i sortida del radi. Molts canvis seguits al mateix punt indiquen que el radi és massa just per a la cobertura que hi ha.",
    "entraA": "entra a",
    "surtDe": "surt de",
    "pantallaNoActiva": "La pantalla es pot apagar. Toqueu-la de tant en tant.",
    "senseWakeLock": "Aquest navegador no pot mantenir la pantalla encesa. No la bloquegeu."
  },
  "recorregut": {
    "antetitol": "Gimcana #FemHistòria",
    "titol": "El barri d'Hostafrancs, carrer a carrer",
    "intro": "Un recorregut pels punts amb història del barri. A cada parada hi trobareu un vídeo de la sèrie #FemHistòria i una pregunta per respondre…",
    "progres_one": "{{fets}} de {{total}} punt",
    "progres_other": "{{fets}} de {{total}} punts",
    "puntsAcumulats_one": "{{punts}} punt",
    "puntsAcumulats_other": "{{punts}} punts"
  }
}
